<!-- Persistent end-of-life notice shown on the Ad Planner landing page -->
<template>
  <v-alert
    dense
    text
    tile
    class="my-0"
    border="left"
    type="warning"
    icon="mdi-alert-outline">
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  name: 'EolBanner',

  computed: {
    message () {
      return 'Starting September 30, we are retiring the current Ad Planner interface to make way for our new Smart Ad experience.'
    }
  }
}
</script>

<style scoped lang="scss">
.v-alert {
  font-size: 0.875rem;
}
</style>
